import { Button } from "react-migration/components/DeprecatedButton";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { router } from "src/js/router/react-router";
import ROUTES from "src/js/router/routes";

type SiteHeaderProps = {
  _id: string;
  results?: number | undefined;
  title: string;
};

export const SiteHeader = ({ _id, results, title }: SiteHeaderProps) => {
  const { t } = useTranslation();
  const handleRedirectToSite = () => {
    router.push({
      name: ROUTES.SITES,
      query: {
        card_page: "summary",
        site_id: _id,
      },
    });
  };

  return (
    <div className="flex justify-between items-center pb-2">
      <div className="flex items-baseline gap-2">
        <h3 className="text-base text-neutral-800 font-semibold">{title}</h3>
        <span className="flex gap-1 text-neutral-600">
          <span className="font-semibold">{results}</span>
          <span>{t("dashboard.planning_alerts.results")}</span>
        </span>
      </div>
      <div className="min-w-[130px] flex justify-end">
        <Button.Secondary onClick={handleRedirectToSite}>
          {t("dashboard.planning_alerts.go_to_site_btn")}
        </Button.Secondary>
      </div>
    </div>
  );
};
